/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React, { useEffect, useState, useRef } from 'react';
import { CommonDropdown, RegularButton, CommonInput, ICommonDropdownOption, FullScreenLoading } from 'pg-ui-library';
import { useNavigate, useParams } from 'react-router-dom';
import { ISupportDesk } from 'src/interfaces';
import { useQuery } from '@tanstack/react-query';
import SupportDeskService from 'src/services/support-desk.service';
import { useAddSupportTicketReply } from '../mutations/add-update-support.mutation';
import { useFormik } from 'formik';
import { IReply } from 'src/interfaces';
import * as yup from 'yup';
import Arrow from 'src/assets/arrow-left-black.svg';
import attachment from 'src/assets/attachment.svg';
import attachmentBlue from 'src/assets/attachment-blue.svg';
import {
  Container,
  ContainerDetail,
  ArrowBack,
  ConversationSection,
  Conversation,
  ConversationEntry,
  SeparatorLineStraight,
  TicketProfile,
  ProfileImage,
  ProfileInitial,
  ProfileDetails,
  Message,
  ReplyArea,
  ReplyHeader,
  ReopenContainer,
  ReplyProfileImage,
  ReplyProfileDetails,
  ReplyTextarea,
  ActionButtonsWrapper,
  FormattingOptions,
  FormattingButton,
  ButtonContainer,
  DiscardButton,
  PostButton,
  TicketDetails,
  TicketDetailsTitle,
  TicketDetailsText,
  RightTicketDetailsText,
  TicketDetailsTextAns,
  HeaderTop,
  RightSideHeader,
} from './styles';

import { TicketReopenModal } from '../components/modal-support';

import { DateTime } from 'luxon';

export enum Ticket {
  OPEN = 'Open',
  OPEN_value = 'Open',
  IN_PROGRESS = 'In Progress',
  IN_PROGRESS_value = 'In Progress',
  ON_HOLD = 'On Hold',
  ON_HOLD_value = 'On Hold',
  RESOLVED = 'Resolved',
  RESOLVED_value = 'Resolved',
  CANCELLED = 'Cancelled',
  CANCELLED_value = 'Cancelled',
}

const myticketOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: Ticket.OPEN,
    value: Ticket.OPEN_value,
  },
  {
    key: '2',
    label: Ticket.ON_HOLD,
    value: Ticket.ON_HOLD_value,
  },
  {
    key: '3',
    label: Ticket.IN_PROGRESS,
    value: Ticket.IN_PROGRESS_value,
  },
  {
    key: '4',
    label: Ticket.RESOLVED,
    value: Ticket.RESOLVED_value,
  },
  {
    key: '5',
    label: Ticket.CANCELLED,
    value: Ticket.CANCELLED_value,
  },
];

const getInitials = (name: string | undefined) => {
  if (!name) return '';
  const nameParts = name.trim().split(' ');
  if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
  return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
};

const ProfilePicture: React.FC<{ src?: string; name?: string }> = ({ src, name }) => {
  if (src) {
    return <ProfileImage src={src} alt="User Profile" />;
  } else {
    const initials = getInitials(name);
    return <ProfileInitial>{initials}</ProfileInitial>;
  }
};

const downloadAttachment = async (
  attachment: { id?: string; attachmentUrl?: string; attachmentName?: string },
  fallbackType: 'ticket' | 'reply' = 'ticket'
) => {
  try {
    const type: 'ticket' | 'reply' =
      attachment.attachmentUrl?.includes('type=reply') || fallbackType === 'reply' ? 'reply' : 'ticket';
    const attachmentId = attachment.id || attachment.attachmentUrl?.match(/download-attachment\/([^/?]+)/)?.[1];

    if (!attachmentId) {
      throw new Error('Attachment id not found');
    }

    const blob = await SupportDeskService.downloadAttachment(attachmentId, type);
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = attachment.attachmentName || 'attachment';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Error downloading attachment', error);
  }
};

const SupportDeskDetail: React.FC = () => {
  const navigate = useNavigate();

  const replyAddSupport = useAddSupportTicketReply();
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const { ticketId } = useParams<{ ticketId: string }>();
  const companyId = '';
  const [statusTicket, setStatusTicket] = useState<string>('');
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { isFetching, data, refetch } = useQuery(['support-desk-reply'], async () => {
    const result = await SupportDeskService.getSupportTicketsReply({
      companyId,
      ticketId,
    });
    return result;
  });

  const handleBackClick = () => {
    navigate('/support-desk');
  };

  const ticketIdShown = data?.supportTicket?.supportNumber;
  const supportTicket = data?.supportTicket;
  const supportTicketDetail = data?.supportTicket as ISupportDesk | undefined;
  const replies = data?.replies || [];

  const attachments = supportTicket?.attachments || [];
  const createdDate = supportTicket?.CreatedTo ? DateTime.fromISO(supportTicket.CreatedTo) : DateTime.now();

  // const statusMapping: { [key: string]: { label: string; color: string } } = {
  //   [Ticket.OPEN_value]: { label: Ticket.OPEN, color: '#E67E22' },
  //   [Ticket.ON_HOLD_value]: { label: Ticket.ON_HOLD, color: '#F39C12' },
  //   [Ticket.IN_PROGRESS_value]: { label: Ticket.IN_PROGRESS, color: '#337ECF' },
  //   [Ticket.RESOLVED_value]: { label: Ticket.RESOLVED, color: '#6FC38A' },
  //   [Ticket.CANCELLED_value]: { label: Ticket.CANCELLED, color: '#E74C3C' },
  // };

  const statusMapping: { [key: string]: { label: string; color: string } } = {
    [Ticket.OPEN_value.toLowerCase()]: { label: Ticket.OPEN, color: '#E67E22' },
    [Ticket.ON_HOLD_value.toLowerCase()]: { label: Ticket.ON_HOLD, color: '#F39C12' },
    [Ticket.IN_PROGRESS_value.toLowerCase()]: { label: Ticket.IN_PROGRESS, color: '#337ECF' },
    [Ticket.RESOLVED_value.toLowerCase()]: { label: Ticket.RESOLVED, color: '#6FC38A' },
    [Ticket.CANCELLED_value.toLowerCase()]: { label: Ticket.CANCELLED, color: '#E74C3C' },
  };

  const getStatusDetails = (status: string) => {
    return statusMapping[status] || { label: status, color: '#BDC3C7' };
  };

  useEffect(() => {
    if (supportTicket) {
      setStatusTicket(supportTicket.status ?? '');
    }
  }, [supportTicket]);

  const validationSchema = yup.object({
    description: yup.string().required('Description is required'),
  });

  const formik = useFormik({
    initialValues: {
      module: '',
      subject: '',
      description: '',
      attachments: [],
    },
    validationSchema,
    onSubmit: async (values: IReply) => {
      if (!ticketId) {
        console.error('Ticket ID is missing');
        return;
      }
      try {
        const formData = new FormData();
        formData.append('module', values.module || '');
        formData.append('subject', values.subject || '');
        formData.append('description', values.description || '');
        formData.append('status', 'open');
        uploadedFiles.forEach(file => {
          formData.append('attachments', file);
        });
        await replyAddSupport.mutateAsync({ ticketId, ticket: formData });
        refetch();
        formik.resetForm();
        setUploadedFiles([]);
      } catch (error) {
        console.error('Error during submission of Ticket', error);
      }
    },
  });

  const fileInputRef = React.useRef<any>(null);
  const handleFileUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current?.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    setUploadedFiles(prevFiles => [...prevFiles, ...files]);
    formik.setFieldValue('fileUpload', files);
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
    formik.setFieldValue('fileUpload', updatedFiles);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.log('fileInputRef.current is null');
    }
  };

  const HIDDEN_REPLY_STATUSES = [Ticket.CANCELLED_value, Ticket.RESOLVED_value];

  return (
    <Container>
      <TicketReopenModal isOpen={isOpen} setIsOpen={setIsOpen} supportTicket={supportTicketDetail} />
      {replyAddSupport.isLoading && <FullScreenLoading />}
      <HeaderTop>
        <ArrowBack src={Arrow} onClick={handleBackClick} />
        <h2>Ticket Chat</h2>
      </HeaderTop>
      <ContainerDetail>
        <ConversationSection>
          <Conversation>
            <h2 style={{ marginLeft: '7px', fontSize: '24px' }}>
              <strong>Ticket ID- #</strong>
              {ticketIdShown}
            </h2>
            <ConversationEntry>
              <TicketProfile>
                <ProfilePicture src={supportTicket?.userProfileUrl ?? undefined} name={supportTicket?.userFirstName} />
                <ProfileDetails>
                  <TicketDetailsText>
                    <span style={{ marginRight: '10px' }}>{supportTicket?.userFirstName}</span>
                    <span style={{ color: '#9399B2' }}>{createdDate.toRelative() || 'Unknown'}</span>
                  </TicketDetailsText>
                </ProfileDetails>
              </TicketProfile>
              <Message>
                <p>{supportTicket?.description}</p>
              </Message>
              <div>
                <p>
                  {attachments && attachments.length > 0 && (
                    <img
                      src={attachmentBlue}
                      alt="Formatting Icon"
                      style={{ height: '17px', margin: '0px 10px 0px 2px' }}
                    />
                  )}
                  {attachments.map((attachment, index) => (
                    <React.Fragment key={index}>
                      <a
                        href="#"
                        onClick={e => {
                          e.preventDefault();
                          downloadAttachment(attachment, 'ticket');
                        }}
                      >
                        {attachment.attachmentName}
                      </a>
                      {index < attachments.length - 1 && ', '}
                    </React.Fragment>
                  ))}
                </p>
              </div>
            </ConversationEntry>
            <SeparatorLineStraight />
            {replies.map((reply, index) => (
              <div>
                <ConversationEntry>
                  <TicketProfile>
                    <ProfilePicture src={reply.userProfileUrl ?? undefined} name={reply.userFirstName} />
                    <ProfileDetails>
                      <TicketDetailsText>
                        <span style={{ marginRight: '10px' }}>{reply.userFirstName}</span>
                        <span style={{ color: '#9399B2' }}>
                          {reply.createdAt ? DateTime.fromISO(reply.createdAt).toRelative() || 'Unknown' : 'Unknown'}
                        </span>
                      </TicketDetailsText>
                    </ProfileDetails>
                  </TicketProfile>

                  <Message>
                    <p>
                      {reply?.description?.includes('??')
                        ? (() => {
                            const [rawFirstPart, secondPart] = reply.description.split('??');

                            const cleanedFirstPart = rawFirstPart.replace(/<\/?[^>]+(>|$)/g, '').trim();
                            const cleanedSecondPart = secondPart?.replace(/<\/?[^>]+(>|$)/g, '').trim();

                            return (
                              <>
                                <b>
                                  <i>{cleanedFirstPart}</i>
                                </b>
                                <br />
                                {cleanedSecondPart}
                              </>
                            );
                          })()
                        : reply?.description?.replace(/<\/?[^>]+(>|$)/g, '') ?? ''}
                    </p>
                  </Message>

                  <div>
                    <p>
                      {reply.attachments && reply.attachments.length > 0 && (
                        <img
                          src={attachmentBlue}
                          alt="Formatting Icon"
                          style={{ height: '17px', margin: '0px 10px 0px 2px' }}
                        />
                      )}
                      {reply.attachments &&
                        reply.attachments.length > 0 &&
                        reply.attachments.map((attachment, index) => (
                          <React.Fragment key={index}>
                            <a
                              href="#"
                              onClick={e => {
                                e.preventDefault();
                                downloadAttachment(attachment, 'reply');
                              }}
                            >
                              {attachment.attachmentName}
                            </a>
                            {index < (reply.attachments || []).length - 1 && ', '}
                          </React.Fragment>
                        ))}
                    </p>
                  </div>
                </ConversationEntry>

                <SeparatorLineStraight />
              </div>
            ))}
          </Conversation>
          {statusTicket !== 'solved' &&
            statusTicket !== 'cancelled' &&
            statusTicket !== 'resolved' &&
            statusTicket !== 'Resolved' &&
            statusTicket !== 'Cancelled' &&
            statusTicket !== 'Solved' && (
              <ReplyArea>
                <ReplyHeader>
                  <ProfilePicture
                    src={supportTicket?.userProfileUrl ?? undefined}
                    name={supportTicket?.userFirstName}
                  />
                  <ReplyProfileDetails>
                    <TicketDetailsText>{supportTicket?.userFirstName}</TicketDetailsText>
                  </ReplyProfileDetails>
                </ReplyHeader>
                <ReplyTextarea
                  placeholder="Enter here..."
                  value={formik.values.description}
                  onChange={event => formik.setFieldValue('description', event.target.value)}
                />

                <div
                  style={{
                    width: '55%',
                    marginTop: '0px',
                    paddingTop: '0px',
                    borderRadius: '7px',
                  }}
                >
                  {uploadedFiles.map((file, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                      <a
                        href={URL.createObjectURL(file)}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#4A4BA9',
                          textDecoration: 'none',
                          marginRight: '10px',
                          fontSize: '12px',
                        }}
                      >
                        {file?.name}
                      </a>
                      <span
                        onClick={() => handleRemoveFile(index)}
                        style={{
                          color: '#4A4BA9',
                          cursor: 'pointer',
                          fontSize: '12px',
                        }}
                      >
                        ✕
                      </span>
                    </div>
                  ))}
                </div>
                <ButtonContainer>
                  <FormattingOptions>
                    <FormattingButton onClick={handleButtonClick} style={{ border: '1px solid #fff' }}>
                      <img src={attachment} alt="Formatting Icon" />
                    </FormattingButton>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: 'none' }}
                      multiple
                      onChange={handleFileChange}
                    />
                  </FormattingOptions>
                  <ActionButtonsWrapper>
                    <DiscardButton>Discard</DiscardButton>
                    <PostButton onClick={() => formik.handleSubmit()}>Post</PostButton>
                  </ActionButtonsWrapper>
                </ButtonContainer>
              </ReplyArea>
            )}

          {(statusTicket === 'cancelled' || statusTicket === 'Cancelled') && (
            <ReopenContainer>
              <p>The ticket has been Cancelled. If you want, you can reopen it.</p>
              <DiscardButton
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                Reopen
              </DiscardButton>
            </ReopenContainer>
          )}
        </ConversationSection>
        <TicketDetails>
          <TicketDetailsTitle>Ticket Information</TicketDetailsTitle>
          <SeparatorLineStraight />
          <RightTicketDetailsText style={{ fontSize: '18px', color: '#1C1B3A', marginBottom: '12px' }}>
            <strong> {supportTicket?.userLastName} Submitted this Request</strong>
          </RightTicketDetailsText>
          <RightTicketDetailsText>
            <strong>Module:</strong>
          </RightTicketDetailsText>
          <TicketDetailsTextAns>
            {(() => {
              const module = supportTicket?.module.toLowerCase();
              let label = '';
              if (module === 'hrprofile' || module === 'hr_profile') {
                label = 'HR Profile';
              } else if (module === 'benefits') {
                label = 'Benefit';
              } else if (module === 'pay_history' || module === 'payroll') {
                label = 'Payroll';
              } else if (module === 'tax' || module === 'tax_forms') {
                label = 'Tax Forms';
              } else {
                label = supportTicket?.module || '';
              }
              return label;
            })()}
          </TicketDetailsTextAns>

          <RightTicketDetailsText>
            <strong>Sub Category:</strong>
          </RightTicketDetailsText>
          <TicketDetailsTextAns>{supportTicket?.subCategory}</TicketDetailsTextAns>
          <RightTicketDetailsText>
            <strong>Description:</strong>
          </RightTicketDetailsText>
          <TicketDetailsTextAns>{supportTicket?.description}</TicketDetailsTextAns>
          <RightTicketDetailsText>
            <strong>Priority:</strong>
          </RightTicketDetailsText>
          <TicketDetailsTextAns>{supportTicket?.priority}</TicketDetailsTextAns>
          <RightTicketDetailsText>
            <strong>Attachments:</strong>{' '}
          </RightTicketDetailsText>
          {attachments.length > 0 && (
            <TicketDetailsTextAns>
              <img src={attachmentBlue} alt="Formatting Icon" style={{ height: '18px', margin: '0px 10px 0px 2px' }} />
              {attachments.map((attachment, index) => (
                <React.Fragment key={index}>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      downloadAttachment(attachment, 'ticket');
                    }}
                  >
                    {attachment.attachmentName}
                  </a>
                  {index < attachments.length - 1 && ', '}
                </React.Fragment>
              ))}
            </TicketDetailsTextAns>
          )}
          <RightTicketDetailsText>
            <strong>Assignee:</strong>
          </RightTicketDetailsText>
          <TicketDetailsTextAns>{supportTicket?.priority}</TicketDetailsTextAns>
          <RightTicketDetailsText>
            <strong>Status:</strong>
          </RightTicketDetailsText>
          <TicketDetailsTextAns>
            <RegularButton
              style={{
                margin: '2px 0px 2px 0px',
                backgroundColor: getStatusDetails(supportTicket?.status ?? '').color,
                color: 'white',
                border: 'none',
                padding: '5px 10px',
                borderRadius: '4px',
              }}
            >
              {getStatusDetails(supportTicket?.status ?? '').label}
            </RegularButton>
          </TicketDetailsTextAns>
          <RightTicketDetailsText>
            <strong>Created :</strong>
          </RightTicketDetailsText>
          <TicketDetailsTextAns>{createdDate.toRelative() || 'Unknown'}</TicketDetailsTextAns>
        </TicketDetails>
      </ContainerDetail>
    </Container>
  );
};

export default SupportDeskDetail;
